import React, { useRef, useEffect, useState } from "react";
import env from "../../../env";
import Status from "../../Components/Status";
import errortrans from "../../../translate/error";
import tabletrans from "../../../translate/tables";
import formtrans from "../../../translate/forms";
import ProductName from "../ProductData/ProductName";
import ProductSKU from "../ProductData/ProductSku";
import ProductPrice from "../ProductData/ProductPrice";
import ShemshName from "./ShemshName";
import ShemshSku from "./ShemshSku";

function ShemshDetailHolder(props) {
  const url = window.location.pathname.split("/")[3];
  const direction = props.lang ? props.lang.dir : errortrans.defaultDir;
  const lang = props.lang ? props.lang.lang : errortrans.defaultLang;
  const [error, setError] = useState({ errorText: "", errorColor: "brown" });
  const [rangeArray, setRangeArray] = useState([]);
  const [content, setContent] = useState("");
  const [filters, setFilters] = useState({});
  const [purchase, setPurchase] = useState("");
  const [updateContent, setUpdateContent] = useState(1);
  const [productChange, setProductChange] = useState("");

  useEffect(() => {
    if (url === "new") return;
    var postOptions = {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ shemshId: url }),
    };

    fetch(env.siteApi + "/panel/product/fetch-shemsh", postOptions)
      .then((res) => res.json())
      .then(
        (result) => {
          if (result.error) {
            setError({ errorText: result.error, errorColor: "brown" });
            setTimeout(
              () => setError({ errorText: "", errorColor: "brown" }),
              3000
            );
          } else {
            setError({ errorText: "سرویس پیدا شد", errorColor: "green" });
            setUpdateContent(1);
            setContent(result);
            setFilters(result.filter ? result.filter.filters : {});
            setRangeArray(result.filter ? result.filter.range : []);
            setTimeout(
              () => setError({ errorText: "", errorColor: "brown" }),
              2000
            );
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }, []);
  const saveProducts = (navigateBack) => {
    //if(newCustomer) {
    var postOptions = {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        shemshId: url,
        ...productChange,
        range: rangeArray,
      }),
    };

    fetch(env.siteApi + "/panel/product/edit-shemsh", postOptions)
      .then((res) => res.json())
      .then(
        (result) => {
          if (result.error) {
            setError({ errorText: result.error, errorColor: "brown" });
            setTimeout(
              () => setError({ errorText: "", errorColor: "brown" }),
              3000
            );
          } else {
            setError({ errorText: result.success, errorColor: "green" });
            if (navigateBack) {
              setTimeout(() => {
                window.history.back();
              }, 2000);
            }
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };
  if (!updateContent) return <div className="new-item">{env.loader}</div>;
  else
    return (
      <div className="new-item" style={{ direction: direction }}>
        <div className="create-product">
          <h4>{tabletrans.createProduct[lang]}</h4>
          {content || url === "new" ? (
            <div className="pages-wrapper">
              <ShemshName
                direction={direction}
                lang={lang}
                content={content}
                productChange={productChange}
                setProductChange={setProductChange}
                setUpdateContent={setUpdateContent}
                setContent={setContent}
                setRangeArray={setRangeArray}
                rangeArray={rangeArray}
                saveProducts={saveProducts}
              />
              {url === "new" || content ? (
                <ShemshSku
                  direction={direction}
                  lang={lang}
                  content={content}
                  productChange={productChange}
                  setProductChange={setProductChange}
                  setFilters={setFilters}
                />
              ) : (
                <></>
              )}

              <div className="create-btn-wrapper">
                <div className="dense-btn">
                  <input
                    className="switch-input"
                    type="checkbox"
                    id="switch-3"
                  />
                </div>

                <div className="save-btn" onClick={() => saveProducts(false)}>
                  {formtrans.saveChanges[lang]}
                </div>
                <div className="save-btn" onClick={() => saveProducts(true)}>
                  {formtrans.saveAndClose[lang]}
                </div>
                <div
                  className="cancel-btn"
                  onClick={() => window.history.back()}
                >
                  {formtrans.cancel[lang]}
                </div>
              </div>
            </div>
          ) : (
            <div>{env.loader}</div>
          )}
        </div>
      </div>
    );
}
export default ShemshDetailHolder;
